import { LegendIcon } from '/b2b/common/components/Charts';

export const FIELDS = {
    passed: 'passed',
    failed: 'failed',
    error: 'error',
};

export const LABELS = {
    [FIELDS.passed]: 'common.pass',
    [FIELDS.failed]: 'common.fail',
    [FIELDS.error]: 'common.error',
};

export const COMMON_OPTIONS = {
    grid: {
        containLabel: true,
    },
    legend: {
        icon: LegendIcon,
        orient: 'horizontal',
        bottom: 'bottom',
    },
    xAxis: {
        axisLine: { show: true },
        axisTick: { show: false },
        splitLine: { show: false },
    },
    yAxis: {
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: { show: true },
    },
};

export const VERTICAL_YAXIS_OPTIONS = {
    grid: {
        containLabel: true,
    },
    yAxis: {
        minInterval: 1,
        type: 'value',
        nameLocation: 'middle',
        nameTextStyle: {
            fontWeight: 'bold',
        },
    },
};

export const CATEGORY_XAXIS_OPTIONS = {
    xAxis: {
        type: 'category',
    },
};

export const BAR_CHART_TOOLTIP = {
    confine: true,
    trigger: 'axis',
    axisPointer: {
        type: 'shadow',
    },
};
